<template>
    <v-card>
        <v-form
        ref="form"
        v-model="isFormValid"
        lazy-validation
        @submit.prevent="submit"
        >
        <v-card-text>
            <v-container>
            <v-row>
                <v-col cols="12" sm="12" md="12">
                <v-text-field
                    v-model="selectedItem.name"
                    :rules="formRules.nameRules"
                    label="Nome"
                    required
                    :disabled="selectedIndex != -1 && ['Administrador', 'Cliente'].includes(selectedItem.name)"
                    hide-details="auto"
                ></v-text-field>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12" sm="12" md="12">
                <v-autocomplete
                    v-model="selectedItem.permissions"
                    :items="permissionOptions"
                    :rules="formRules.permissionRules"
                    item-text="display_name"
                    item-value="name"
                    label="Permissões"
                    hide-details="auto"
                    multiple
                    clearable
                    chips
                    deletable-chips
                    small-chips
                ></v-autocomplete>
                </v-col>
            </v-row>
            </v-container>
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
            color="#0dc4b8" 
            text
            @click="$emit('onClose'); "
            >
            Cancelar
            </v-btn>
            <v-btn
            color="#0dc4b8" 
            text
            type="submit"
            @click="submit"
            :disabled="isLoading"
            :loading="isLoading"
            >
            {{ formButtonText }}
            </v-btn>
        </v-card-actions>
        </v-form>
    </v-card>
</template>


<script>
import { mapMutations } from 'vuex';
import UserRolesService from '../../services/user_roles.service';

export default {
  name: 'UserRolesForm',
  props: {
    selectedIndex: {
        type: Number,
        required: false,
        default: -1,
    },
    selectedItem: {
        type: Object,
        required: true,
    },
  },
  data: () => ({
    formRules: {
      nameRules: [
        v => !!v || 'Nome é obrigatório',
      ],
      permissionRules: [
        v => !!v || 'Permissões é obrigatório',
        v => !!v && v.length > 0 || 'Ao menos uma permissão deve ser concedida',
      ],
    },
    isFormValid: true,
    isLoading: true,
    permissionOptions: [],
  }),
  computed: {
    formButtonText () {
      return this.selectedIndex === -1 ? 'Criar' : 'Editar'
    },
  },
  mounted() {
    this.loadFormOptions();
  },
  methods: {
    ...mapMutations(["showSnackbar"]),

    loadFormOptions () {
      UserRolesService.permissions({ sort: 'name' })
        .then(({ data }) => {
          this.permissionOptions = data.data;
        })
        .catch(() => { this.showSnackbar({ text: "Ops! Ocorreu um erro inesperado", color:"error" }) })
        .finally(() => setTimeout(() => (this.isLoading = false), 300));
    },

    submit () {
      if(this.$refs.form.validate()) {
        this.isLoading = true;
        if (this.selectedIndex > -1) {
          UserRolesService.put(this.selectedItem, this.selectedItem.id)
            .then(() => {
              this.showSnackbar({ text: "Registro atualizado com sucesso!", color:"success" })
            })
            .catch(() => { this.showSnackbar({ text: "Ops! Ocorreu um erro inesperado", color:"error" }) })
            .finally(() => setTimeout(() => { this.isLoading = false; this.$emit('onSubmit'); }, 300));
        } else {
          UserRolesService.store(this.selectedItem)
            .then(() => {
              this.showSnackbar({ text: "Registro criado com sucesso!", color:"success" })
            })
            .catch(() => { this.showSnackbar({ text: "Ops! Ocorreu um erro inesperado", color:"error" }) })
            .finally(() => setTimeout(() => { this.isLoading = false; this.$emit('onSubmit'); }, 300));
        }
      }
    },
  },
}
</script>
